import React from 'react'
import { Grid, Hidden, Typography } from '@mui/material'
import clsx from 'clsx'

import { useStyles } from './style'

const FloatingToolbar = ({ open, title, toolbarEl, className }) => {
  const classes = useStyles()

  if (!open) return null

  return (
    <Grid
      container
      alignItems='center'
      wrap='nowrap'
      className={clsx(classes.root, className)}
    >
      <Hidden smDown>
        <Grid item className={classes.title}>
          <Typography variant='h6' noWrap data-test='article-toolbar-title'>
            {title}
          </Typography>
        </Grid>
      </Hidden>
      <Grid item xs={12} sm='auto'>
        {toolbarEl}
      </Grid>
    </Grid>
  )
}

export default FloatingToolbar
